const CustomerAccountLoginTypes = {
  FIDO: 'fido',
  GUEST: 'guest',
  MERCHANT_CREDENTIALS: 'merchant_credentials',
  OTHER: 'other',
  THIRD_PARTY: 'third_party',
};

module.exports = CustomerAccountLoginTypes;
